import { useState } from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { openWhatsApp } from "../../lib/whatsapp";

export const CTAFinal = () => {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    objetivo: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.nombre || !form.objetivo) return;
    setSubmitting(true);
    const message = `Hola Aitor, soy ${form.nombre}. Mi email es ${
      form.email || "(no facilitado)"
    } y mi teléfono ${form.telefono || "(no facilitado)"}. Mi objetivo es: ${
      form.objetivo
    }. CAMBIO`;
    openWhatsApp(message);
    setTimeout(() => setSubmitting(false), 600);
  };

  return (
    <section
      id="contacto"
      data-testid="section-cta-final"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-zinc-900 overflow-hidden"
    >
      {/* accent corner */}
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#FF5A1F]/10 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            07 — Empieza ahora
          </p>
          <h2
            data-testid="cta-heading"
            className="font-display font-black uppercase text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter"
          >
            Tu <span className="text-[#FF5A1F]">CAMBIO</span> empieza
            <br />
            con un mensaje.
          </h2>
          <p className="mt-6 text-lg text-zinc-400 leading-relaxed">
            Rellena el formulario y te abriré WhatsApp con tu mensaje listo para
            enviar. Sin compromiso. Sin promesas vacías.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="contact-form"
          className="mt-14 max-w-3xl mx-auto bg-zinc-950 border border-zinc-800 p-8 sm:p-12 grid sm:grid-cols-2 gap-6"
        >
          <div className="sm:col-span-1">
            <label
              htmlFor="nombre"
              className="block text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2"
            >
              Nombre *
            </label>
            <input
              id="nombre"
              name="nombre"
              type="text"
              required
              value={form.nombre}
              onChange={handleChange}
              data-testid="form-input-nombre"
              placeholder="Cómo te llamas"
              className="bg-zinc-900 border-b-2 border-zinc-800 focus:border-[#FF5A1F] text-white px-4 py-3 outline-none transition-colors w-full placeholder:text-zinc-600"
            />
          </div>
          <div className="sm:col-span-1">
            <label
              htmlFor="email"
              className="block text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              data-testid="form-input-email"
              placeholder="tu@email.com"
              className="bg-zinc-900 border-b-2 border-zinc-800 focus:border-[#FF5A1F] text-white px-4 py-3 outline-none transition-colors w-full placeholder:text-zinc-600"
            />
          </div>
          <div className="sm:col-span-1">
            <label
              htmlFor="telefono"
              className="block text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2"
            >
              Teléfono
            </label>
            <input
              id="telefono"
              name="telefono"
              type="tel"
              value={form.telefono}
              onChange={handleChange}
              data-testid="form-input-telefono"
              placeholder="+34 ..."
              className="bg-zinc-900 border-b-2 border-zinc-800 focus:border-[#FF5A1F] text-white px-4 py-3 outline-none transition-colors w-full placeholder:text-zinc-600"
            />
          </div>
          <div className="sm:col-span-1">
            <label
              htmlFor="objetivo"
              className="block text-xs uppercase tracking-widest text-zinc-500 font-bold mb-2"
            >
              Objetivo *
            </label>
            <input
              id="objetivo"
              name="objetivo"
              type="text"
              required
              value={form.objetivo}
              onChange={handleChange}
              data-testid="form-input-objetivo"
              placeholder="Ej: perder 12 kg"
              className="bg-zinc-900 border-b-2 border-zinc-800 focus:border-[#FF5A1F] text-white px-4 py-3 outline-none transition-colors w-full placeholder:text-zinc-600"
            />
          </div>

          <div className="sm:col-span-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-4 border-t border-zinc-800">
            <button
              type="submit"
              disabled={submitting}
              data-testid="form-submit-btn"
              className="group flex-1 inline-flex items-center justify-center gap-3 bg-[#FF5A1F] hover:bg-[#E04814] disabled:opacity-60 transition-colors text-white font-bold uppercase tracking-wider px-8 py-4 text-base"
            >
              <MessageCircle size={20} />
              {submitting ? "Abriendo WhatsApp..." : "Enviar y empezar CAMBIO"}
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <button
              type="button"
              onClick={() =>
                openWhatsApp(
                  "Hola Aitor, prefiero hablar directo por WhatsApp. CAMBIO"
                )
              }
              data-testid="form-direct-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 border-2 border-zinc-700 hover:border-white text-white font-bold uppercase tracking-wider px-6 py-4 text-base transition-colors"
            >
              Hablar ya
            </button>
          </div>

          <p className="sm:col-span-2 text-xs text-zinc-600 leading-relaxed">
            Al enviar este formulario abriremos WhatsApp con un mensaje listo
            para enviar a Aitor. Tus datos no se almacenan en ninguna base de
            datos.
          </p>
        </form>
      </div>
    </section>
  );
};
